<!-- eslint-disable max-len -->
<template>
  <div>
    <!--Messages d'erreur-->
    <div class="justify-content-center mx-auto col-12 error-messages-container">
      <Alert
        type="warning"
        message="Veuillez vérifier que tous les champs sont correctement remplis"
        :visible="validationError"
        @close="validationError = false" />

      <Alert
        type="danger"
        message="Nous rencontrons des difficultés pour vous connecter. Veuillez réessayer dans quelques instants."
        :visible="authError"
        @close="authError = false" />

      <Alert
        type="danger"
        message="L'identifiant ou le mot de passe est incorrect. Vérifiez vos informations."
        :visible="invalidCredentials"
        @close="invalidCredentials = false" />

      <Alert
        type="danger"
        message="Votre compte n'est pas actif. Contactez le support pour plus d'informations."
        :visible="disabledUser"
        @close="disabledUser = false" />
    </div>
    <!--#Messages d'erreur-->

    <div class="row justify-content-center">
      <form @submit="formSubmit" class="col-12">
        <fieldset class="login-fields-container">
          <div class="form-group row">
            <label for="idInput" class="col-sm-12 col-md-5 col-form-label">Identifiant</label>
            <div class="col-sm-12 col-md-7">
              <input id="idInput"
                     type="text"
                     class="form-control"
                     v-model="name"
                     :class="{ 'is-invalid': formSubmitted && !this.$v.name.required }"
                     @input="onLoginInput">
              <div v-if="formSubmitted && !this.$v.name.required" class="mt-1">
                <div class="text-danger small">
                  Champ requis
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="passwordInput" class="col-sm-12 col-md-5 col-form-label">
              Mot de passe
            </label>
            <div class="col-sm-12 col-md-7">
              <input id="passwordInput"
                     :type="passwordType"
                     class="form-control"
                     :class="{ 'is-invalid': formSubmitted && !this.$v.password.required }"
                     @input="onPasswordInput"
                     v-model="password">
              <div v-if="formSubmitted && !this.$v.password.required" class="mt-1">
                <div class="text-danger small">
                  Champ requis
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="form-check my-4 text-center">
          <input type="checkbox" class="form-check-input"
                 @click="switchVisibility" id="switchVisibility">
          <label class="form-check-label text-label" for="switchVisibility">
            Afficher le mot de passe
          </label>
        </div>

        <div class="row justify-content-center my-4">
          <div class="col-12 col-sm-8 mt-3">
            <button type="submit" class="btn btn-block btn-sm text-white fond-indigo">
              Se connecter
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import Alert from '../Alert.vue';

export default {
  data() {
    return {
      passwordType: 'password',
      validationError: false,
      authError: false,
      invalidCredentials: false,
      disabledUser: false,
      name: '',
      password: '',
      formSubmitted: false,
    };
  },
  components: {
    Alert,
  },
  methods: {
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    onLoginInput() {
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.authError = false;
      this.invalidCredentials = false;
      this.disabledUser = false;
    },
    onPasswordInput() {
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.authError = false;
      this.invalidCredentials = false;
      this.disabledUser = false;
    },

    formSubmit(e) {
      e.preventDefault();
      this.formSubmitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.validationError = true;
        return;
      }

      const sanitizedData = {
        login: this.name,
        password: this.password,
      };

      axios.post('/auth/api/auth', JSON.stringify(sanitizedData), { headers: { 'content-type': 'application/json' } })
        .then((response) => {
          localStorage.setItem('AUTH_MODE', 'LOGIN');
          axios.get(`/parametrage/api/urls/${response.data.data.storeId}`)
            .then((destination) => {
              let source;
              if (this.$parent.path) {
                // add path if provided
              }
              if (this.$parent.source) {
                source = destination.data[this.$parent.source];
                if (source && source.includes(destination.data.Customers)) {
                  source = source.replace(destination.data.Customers, destination.data.CustomersIS);
                } else if (source && source.includes(destination.data.services)) {
                  source = source.replace(destination.data.services, destination.data.Services);
                }
              } else if (this.$parent.url) {
                source = this.$parent.url + this.$parent.hash;
              } else {
                this.$router.push({ name: 'Error', params: { errorType: 'source' } });
              }

              window.location.href = source;
            });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.invalidCredentials = true;
          } else if (error.response.status === 403) {
            this.disabledUser = true;
          } else {
            this.authError = true;
          }
        });
    },
  },
  validations: {
    name: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.login-fields-container {
  margin-left: 8px;
}

.error-messages-container {
  margin-bottom: 25px !important;
}

.form-check {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
}

.form-check-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 2px solid #ccc;
  border-radius: 4px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  transition: all 0.2s ease;
  margin: 0;
  flex-shrink: 0;
}

.form-check-input:checked {
  background-color: #482882;
  border-color: #482882;
}

.form-check-input:checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.form-check-input:hover {
  border-color: #482882;
}

.form-check-label {
  cursor: pointer;
  margin-left: 8px;
  margin-bottom: 0;
  padding-left: 0;
  user-select: none;
  line-height: 20px;
}
</style>
